import React, { useEffect, useState, useContext } from "react";
import { Layout } from "@shopify/polaris";
import { useLazyQuery } from "@apollo/react-hooks";
import Moment from "moment";
import Baby from "babyparse";
import FileDownload from "js-file-download";
// import hoc
import { withFeature, withErrorBoundary } from "lib/hoc";
// import context
import { PrivateContext } from "lib/context";
// import constant
import constant from "lib/constant/constant";
// import components
import { Banner, Spinner } from "lib/components";
// import query
import { GET_PRODUCT_EXPORT_SETTING } from "app/setup/apollo/queries";
import { GET_PRODUCT_DETAILS } from "app/productOld/apollo/queries";
// import helpers
import { baseHelper } from "lib/helpers";
import productHelper from "./helper/product";

const ExportAsCSV = () => {
  const data = useContext(PrivateContext);
  const { cms, currentUser } = data;
  const isVendor = baseHelper.isVendor(currentUser);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [queryData, setQueryData] = useState();
  const [
    getProductList,
    { data: getProductData, loading: productDetailsLoading, error: productError },
  ] = useLazyQuery(GET_PRODUCT_DETAILS, { variables: { input: queryData } });

  const [getProductSetting, { data: getSettingData, loading: settingLoading, error: settingError }] = useLazyQuery(
    GET_PRODUCT_EXPORT_SETTING
  );

  const [banner, setBanner] = useState({
    title: "",
    status: "",
    isOpen: false,
  });
  useEffect(() => {
    if (
      !productDetailsLoading &&
      !productError &&
      getProductData &&
      getSettingData &&
      !settingLoading &&
      !settingError
    ) {
      const resData = baseHelper.getResponseData(getProductData, constant.gql.GET_PRODUCT_DETAILS);
      const settingResponse = baseHelper.getResponseData(getSettingData, constant.gql.GET_PRODUCT_EXPORT_SETTING);
      let bannerData = false;
      if (!resData) {
        const resError = baseHelper.getResponseError(getProductData, constant.gql.GET_PRODUCT_DETAILS);
        bannerData = {
          title: resError,
          status: constant.CRITICAL,
          isOpen: true,
        };
      }

      if (!resData.length && !resData.vendorData.length) {
        bannerData = {
          title: cms("section.export.message.error.noProduct"),
          status: constant.CRITICAL,
          isOpen: true,
        };
      }
      if (bannerData) {
        setBanner(bannerData);
        setTimeout(() => {}, 2000);
        return;
      }
      const csvData = productHelper.productCSVData(
        resData.getProductDetailData,
        settingResponse,
        true,
        false,
        isVendor
      );
      const csv = Baby.unparse(csvData);
      const date = Moment(new Date(), "DD-MM-YYYY").format("LL");
      FileDownload(csv, `${constant.CONSOLIDATED_PRODUCT} ${date}.csv`);
      setTimeout(() => {
        window.close();
      }, 500);
    }
  }, [
    getProductData,
    productError,
    productDetailsLoading,
    cms,
    getSettingData,
    settingLoading,
    settingError,
    isVendor,
  ]);
  useEffect(() => {
    const exportProduct = () => {
      const dataToFetch = {};
      const { endDate, startDate, status, vendor } = baseHelper.queryParamsFromLocation(data);
      if (status && status.length) {
        dataToFetch.status = status.split(",");
      }
      if (vendor && vendor.length) {
        dataToFetch.vendor = vendor.split(",");
      }
      if (startDate && endDate) {
        dataToFetch.dateRange = { start: startDate, end: endDate };
      }
      setQueryData(dataToFetch);
      getProductList();
      getProductSetting();
    };
    if (isPageLoading) {
      exportProduct();
      setIsPageLoading(false);
    }
  }, [data, getProductList, getProductSetting, isPageLoading]);
  return (
    <Layout>
      {productDetailsLoading && <Spinner isFullPage />}
      <Layout.Section>
        {banner.isOpen && (
          <Banner
            title={banner.title}
            status={banner.status}
            isOpen={banner.isOpen}
            onDismiss={() => setBanner({ isOpen: false, status: "", title: "" })}
          />
        )}
      </Layout.Section>
    </Layout>
  );
};
export default withFeature(withErrorBoundary(ExportAsCSV), { feature: constant.EXPORT_PRODUCT });
